module.exports = __webpack_public_path__ + "static/data-model-3-75cff3c21a903a3328d7e08f5b7e2239.png";